const CHECKOUT_LANDING_KEY = 'open-racer:checkout-landing:v1'

const CHECKOUT_INTENTS = new Set([
  'pricing',
  'manual_line',
  'duplicate_line',
  'track_picker',
  'gopro_import',
  'iracing_import',
  'alfano_import',
  'community_view_limit',
  'telemetry_import',
])

const limit = (value, length) => String(value || '').slice(0, length)

const safePath = value => {
  const path = limit(value, 240)
  return path.startsWith('/') ? path : '/'
}

const safeReferrerHost = value => {
  if (!value) return ''
  try {
    const url = new URL(value)
    return limit(url.hostname, 120)
  } catch (_) {
    return ''
  }
}

const campaignFromSearch = search => {
  let params
  try {
    params = new URLSearchParams(search || '')
  } catch (_) {
    params = new URLSearchParams()
  }

  const campaign = {
    utm_source: limit(params.get('utm_source'), 100),
    utm_medium: limit(params.get('utm_medium'), 100),
    utm_campaign: limit(params.get('utm_campaign'), 100),
    utm_content: limit(params.get('utm_content'), 100),
    utm_term: limit(params.get('utm_term'), 100),
  }

  const landingQuery = new URLSearchParams()
  Object.entries(campaign).forEach(([key, value]) => {
    if (value) landingQuery.set(key, value)
  })

  return {
    ...campaign,
    landing_query: limit(landingQuery.toString(), 240),
  }
}

const currentBrowserInputs = () => ({
  location: typeof window !== 'undefined' ? window.location : { pathname: '/', search: '' },
  referrer: typeof document !== 'undefined' ? document.referrer : '',
  storage: typeof window !== 'undefined' ? window.sessionStorage : null,
})

const captureCheckoutLanding = inputs => {
  const browser = currentBrowserInputs()
  const location = inputs?.location || browser.location
  const referrer = inputs?.referrer ?? browser.referrer
  const storage = inputs?.storage || browser.storage

  if (!storage) {
    return {
      landing_path: safePath(location?.pathname),
      referrer_host: safeReferrerHost(referrer),
      ...campaignFromSearch(location?.search),
    }
  }

  try {
    const existing = storage.getItem(CHECKOUT_LANDING_KEY)
    if (existing) return JSON.parse(existing)
  } catch (_) {}

  const landing = {
    landing_path: safePath(location?.pathname),
    referrer_host: safeReferrerHost(referrer),
    ...campaignFromSearch(location?.search),
  }

  try {
    storage.setItem(CHECKOUT_LANDING_KEY, JSON.stringify(landing))
  } catch (_) {}

  return landing
}

const buildCheckoutContext = inputs => {
  const browser = currentBrowserInputs()
  const location = inputs?.location || browser.location
  const storage = inputs?.storage || browser.storage
  const landing = captureCheckoutLanding({
    location,
    referrer: inputs?.referrer ?? browser.referrer,
    storage,
  })
  const intent = CHECKOUT_INTENTS.has(inputs?.intent) ? inputs.intent : 'unknown'

  return {
    schema_version: 1,
    intent,
    landing_path: safePath(landing.landing_path),
    landing_query: limit(landing.landing_query, 240),
    checkout_path: safePath(location?.pathname),
    referrer_host: limit(landing.referrer_host, 120),
    utm_source: limit(landing.utm_source, 100),
    utm_medium: limit(landing.utm_medium, 100),
    utm_campaign: limit(landing.utm_campaign, 100),
    utm_content: limit(landing.utm_content, 100),
    utm_term: limit(landing.utm_term, 100),
  }
}

module.exports = {
  CHECKOUT_LANDING_KEY,
  CHECKOUT_INTENTS,
  captureCheckoutLanding,
  buildCheckoutContext,
}
